module.exports = __webpack_public_path__ + "img/facebook_icon.96958f3d.svg";